import { BaseObject, IBaseObjectArgs } from '../../../core/business-objects/base-object/base-object.model';

export interface IAccountArgs extends IBaseObjectArgs {
    business?: string;
    title?: string;
    email?: string;
    mobile?: string;
    phone?: string;
    website?: string;
    address?: string;
    vatNumber?: string;

    owner?: string;
    userLimit?: string;
    billingPackage?: string;
    reportsDisabled?: boolean;
    deleted?: boolean;
    workflowEnabled?: boolean;

    sesFromAddress?: string;
    emailFooter?: string;

    // memberships?: Array<string>;
    // accessGroups?: Array<string>;
    // jobStatuses?: Array<string>;
    // lookupTypes?: Array<string>;
    // contactTypes?: Array<string>;
    // jobTypes?: Array<string>;
    // reportLayouts?: Array<string>;
    // jobs?: Array<string>;
    // contacts?: Array<string>;
    // files?: Array<string>;
    // forms?: Array<string>;
    // lookups?: Array<string>;
}

const defaults = () => ({
    business: '',
    title: '',
    email: '',
    mobile: '',
    phone: '',
    website: '',
    address: '',
    vatNumber: '',
    owner: '',
    userLimit: '',
    billingPackage: '',
    reportsDisabled: false,
    deleted: false,
    workflowEnabled: false,
    sesFromAddress: '',
    emailFooter: ''


    // memberships: [],
    // accessGroups: [],
    // jobStatuses: [],
    // lookupTypes: [],
    // contactTypes: [],
    // jobTypes: [],
    // reportLayouts: [],
    // jobs: [],
    // contacts: [],
    // files: [],
    // forms: [],
    // lookups: [],

} as IAccountArgs);

export class Account extends BaseObject {
    business: string;
    title: string;
    email: string;
    mobile: string;
    phone: string;
    website: string;
    address: string;
    vatNumber: string;
    owner: string;

    userLimit: string;
    reportsDisabled: boolean;
    billingPackage: string;
    deleted: boolean;
    workflowEnabled: boolean;

    sesFromAddress: string;
    emailFooter: string;

    // memberships: Array<string>;
    // accessGroups: Array<string>;
    // jobStatuses: Array<string>;
    // lookupTypes: Array<string>;
    // contactTypes: Array<string>;
    // jobTypes: Array<string>;
    // reportLayouts: Array<string>;
    // jobs: Array<string>;
    // contacts: Array<string>;
    // files: Array<string>;
    // forms: Array<string>;
    // lookups: Array<string>;

    constructor(data?: IAccountArgs) {
        super({...defaults(), ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account/account.model.ts